import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { UsuarioRegistroEntity } from "./entities/usuario_registro_entity";
import { Router, ActivatedRoute } from '@angular/router';
import { UsuarioLoginEntity } from '../login/usuario_login_entity';
import { HandleError } from "../../components/common/utils/handleError.component";
import { LoginService } from "../login/login.service";
import { UtilService } from "../../components/common/utils/util.service";
import { ShowHideInput, ShowHideInput2, ShowHideInput3 } from './show-hide-input.directive'
import { PreguntasEntity } from "./entities/preguntas_entity";
import { ModalComponent } from "ng2-bs3-modal/ng2-bs3-modal";

const swal = require("sweetalert2");

@Component({
    selector: 'register',
    templateUrl: 'register.template.html'
})
export class registerComponent implements OnInit {
    usuarioRegistro: UsuarioRegistroEntity;
    esCliente: boolean;
    show = false;
    show2 = false;
    show3 = false;
    private sub: any;
    bandera: number;
    cedula: boolean;
    preguntas: PreguntasEntity[];
    @ViewChild('terminos')
    modal: ModalComponent;
    showLoader: string = "";

    @ViewChild(ShowHideInput)
    input: ShowHideInput;

    @ViewChild(ShowHideInput2)
    input2: ShowHideInput2;

    @ViewChild(ShowHideInput3)
    input3: ShowHideInput3;

    constructor(public utilService: UtilService, private route: ActivatedRoute, private loginService: LoginService, private router: Router, private handleError: HandleError) { }

    toggleShow(e: any, campo: number) {
        if (campo == 1) {
            this.show = !this.show;

            if (this.show) {
                this.input.changeType("text");
            }
            else {
                this.input.changeType("password");
            }
        }
        else if (campo == 2) {
            this.show2 = !this.show2;

            if (this.show2) {
                this.input2.changeType("text");
            }
            else {
                this.input2.changeType("password");
            }
        }
        else {
            this.show3 = !this.show3;

            if (this.show3) {
                this.input3.changeType("text");
            }
            else {
                this.input3.changeType("password");
            }
        }
    }

    cambiaContrasena() {
        this.usuarioRegistro.OtroPassword = "";
        this.cedula = false;
    }

    ngOnInit() {
        this.usuarioRegistro = new UsuarioRegistroEntity();
        this.usuarioRegistro.User = new UsuarioLoginEntity();
        this.usuarioRegistro.Pregunta = 0;
        this.preguntas = new Array<PreguntasEntity>();
        this.esCliente = true;
        this.showLoader = "";
        this.sub = this.route.params.subscribe(params => {
            this.bandera = +params['bandera'];
            if (this.bandera != 1 && this.bandera != 2) {
                this.router.navigate(["/error404"]);
            } else {
                this.loginService.getPreguntas().subscribe(result => {
                    this.preguntas = result;
                },
                    erorr => {
                        swal({
                            title: 'Lo sentimos',
                            text: "Ha ocurrido un error, por favor intentelo más tarde",
                            type: 'error'
                        })
                    });
            }
        });
    }

    verificarUsuario() {
        this.loginService.verificarUsuario(this.usuarioRegistro.User.Usuario).subscribe(
            usuario => {
                this.esCliente = false;
            },
            error => {
                this.handleError.redirectUrl(error)
            }
        );
    }

    verificarCliente() {
        try {
            if (this.usuarioRegistro.Cedula != undefined && this.usuarioRegistro.Cedula != "") {
                if (this.bandera == 1) {
                    this.loginService.verificarCedulaPersona(this.usuarioRegistro.Cedula).subscribe(
                        usuario => {
                            if(usuario.Error == 0){
                                this.esCliente = false;
                                this.cedula = true;
                                this.usuarioRegistro.Nombre = usuario.Nombre;
                                this.usuarioRegistro.Mail = usuario.Mail;
                                this.usuarioRegistro.UsuarioIndEmp= usuario.UsuarioIndEmp;
                               
                            }
                            if(usuario.Error == 1){
                                this.esCliente = true;
                                swal({
                                    title: 'Comprobación de Cédula',
                                    text: "Su usuario ya se encuentra registrado pero aún no ha realizado la activación del mismo; por favor acceda al correo que usó durante el registro y continue con la activación de su cuenta.",
                                    type: 'warning'
                                }).then((function () {
                                    this.usuarioRegistro = new UsuarioRegistroEntity();
                                    this.usuarioRegistro.User = new UsuarioLoginEntity();
                                    this.usuarioRegistro.User.Tipo = this.bandera;
                                }).bind(this));
                            }
                            if(usuario.Error == 2){
                                this.esCliente = true;
                                swal({
                                    title: 'Comprobación de Cédula',
                                    text: usuario.MensajeError,
                                    type: 'warning'
                                }).then((function () {
                                    this.usuarioRegistro = new UsuarioRegistroEntity();
                                    this.usuarioRegistro.User = new UsuarioLoginEntity();
                                    this.usuarioRegistro.User.Tipo = this.bandera;
                                }).bind(this));
                            }
                            if(usuario.Error == 3){
                                this.esCliente = true;
                                swal({
                                    title: 'Comprobación de Cédula',
                                    text: usuario.MensajeError,
                                    type: 'error'
                                }).then((function () {
                                    this.usuarioRegistro = new UsuarioRegistroEntity();
                                    this.usuarioRegistro.User = new UsuarioLoginEntity();
                                    this.usuarioRegistro.User.Tipo = this.bandera;
                                }).bind(this));
                            }
                            if(usuario.Error == 4){
                                this.esCliente = true;
                                swal({
                                    title: 'Comprobación de Cédula',
                                    text: usuario.MensajeError,
                                    type: 'error'
                                }).then((function () {
                                    this.usuarioRegistro = new UsuarioRegistroEntity();
                                    this.usuarioRegistro.User = new UsuarioLoginEntity();
                                    this.usuarioRegistro.User.Tipo = this.bandera;
                                }).bind(this));
                            }
                        },
                        error => {
                            this.esCliente = true;
                            this.usuarioRegistro = new UsuarioRegistroEntity();
                            this.usuarioRegistro.User = new UsuarioLoginEntity();
                            this.usuarioRegistro.User.Tipo = this.bandera;

                            swal({
                                title: 'Comprobación de Cédula',
                                text: "La cédula ingresada no consta en los registros de Tecniseguros, o ya se encuentra en uso",
                                type: 'warning'
                            }).then((function () {
                                this.usuarioRegistro = new UsuarioRegistroEntity();
                                this.usuarioRegistro.User = new UsuarioLoginEntity();
                            }).bind(this));
                        }
                    );
                } else {
                    this.loginService.verificarCedulaEmpresa(this.usuarioRegistro.Cedula).subscribe(
                        usuario => {
                            if(usuario.Error == 0){
                                this.esCliente = false;
                                this.cedula = true;
                                this.usuarioRegistro.Nombre = usuario.Nombre;
                                this.usuarioRegistro.Mail = usuario.Mail;
                                this.usuarioRegistro.UsuarioIndEmp= usuario.UsuarioIndEmp;
                                
                            }
                            if(usuario.Error == 1){
                                this.esCliente = true;
                                swal({
                                    title: 'Comprobación de Cédula',
                                    text: "Su usuario ya se encuentra registrado pero aún no ha realizado la activación del mismo; por favor acceda al correo que usó durante el registro y continue con la activación de su cuenta.",
                                    type: 'warning'
                                }).then((function () {
                                    this.usuarioRegistro = new UsuarioRegistroEntity();
                                    this.usuarioRegistro.User = new UsuarioLoginEntity();
                                    this.usuarioRegistro.User.Tipo = this.bandera;
                                }).bind(this));
                            }
                            if(usuario.Error == 2){
                                this.esCliente = true;
                                swal({
                                    title: 'Comprobación de Cédula',
                                    text: usuario.MensajeError,
                                    type: 'warning'
                                }).then((function () {
                                    this.usuarioRegistro = new UsuarioRegistroEntity();
                                    this.usuarioRegistro.User = new UsuarioLoginEntity();
                                    this.usuarioRegistro.User.Tipo = this.bandera;
                                }).bind(this));
                            }
                            if(usuario.Error == 3){
                                this.esCliente = true;
                                swal({
                                    title: 'Comprobación de Cédula',
                                    text: usuario.MensajeError,
                                    type: 'error'
                                }).then((function () {
                                    this.usuarioRegistro = new UsuarioRegistroEntity();
                                    this.usuarioRegistro.User = new UsuarioLoginEntity();
                                    this.usuarioRegistro.User.Tipo = this.bandera;
                                }).bind(this));
                            }
                            if(usuario.Error == 4){
                                this.esCliente = true;
                                swal({
                                    title: 'Comprobación de Cédula',
                                    text: usuario.MensajeError,
                                    type: 'error'
                                }).then((function () {
                                    this.usuarioRegistro = new UsuarioRegistroEntity();
                                    this.usuarioRegistro.User = new UsuarioLoginEntity();
                                    this.usuarioRegistro.User.Tipo = this.bandera;
                                }).bind(this));
                            }
                        },
                        error => {
                            this.esCliente = true;
                            this.usuarioRegistro = new UsuarioRegistroEntity();
                            this.usuarioRegistro.User = new UsuarioLoginEntity();
                            swal({
                                title: 'Comprobación de Cédula',
                                text: "La cédula ingresada no consta en los registros de Tecniseguros, o ya se encuentra en uso",
                                type: 'warning'
                            }).then((function () {
                                this.usuarioRegistro = new UsuarioRegistroEntity();
                                this.usuarioRegistro.User = new UsuarioLoginEntity();
                                this.usuarioRegistro.User.Tipo = this.bandera;
                            }).bind(this));
                        }
                    );
                }
            } else {
                swal({
                    title: 'Cédula inválida',
                    text: "Ingrese una cédula o RUC",
                    type: 'warning'
                })
            }
        } catch (e) {
            swal({
                title: 'Lo sentimos',
                text: "Ha ocurrido un error al verificar su cédula, por favor inténtelo más tarde",
                type: 'error'
            })
        }
    }

    cambiarCedula() {
        this.esCliente = true;
        this.cedula = false;
        this.usuarioRegistro = new UsuarioRegistroEntity();
        this.usuarioRegistro.User = new UsuarioLoginEntity();
        this.usuarioRegistro.User.Tipo = this.bandera;
    }

    registrarUsuario() {
        this.showLoader = "sk-loading";
        //console.log("persona",  this.usuarioRegistro);
        this.usuarioRegistro.User.Tipo = this.bandera;
        this.loginService.registrarUsuario(this.usuarioRegistro).subscribe(result => {
            this.showLoader = "";
            if (result == true) {
                var varGeneral = this;
                swal({
                    title: 'Registro',
                    // text: "El registro de usuario se ha realizado correctamente, un correo electrónico con el link de activación se ha enviado a la dirección de registro, por favor acceda a su correo para completar el proceso.",
                    text: "El registro de usuario se ha realizado correctamente.",
                    type: 'success'
                }).then((function () {
                    this.usuarioRegistro = new UsuarioRegistroEntity();
                    this.redirect();
                }).bind(this));

            } else {
                if (this.bandera == 2) {
                    swal({
                        title: 'Lo sentimos',
                        text: "El contacto ingresado puede constar como cliente de Tecniseguros, si este es el caso por favor contáctese con su ejecutivo de cuenta",
                        type: 'error'
                    });
                } else {
                    swal({
                        title: 'Lo sentimos',
                        text: "El usuario que se desea crear pertenece a Tecniseguros como cliente o la información se encuentra errónea, por favor contáctese con su ejecutivo de cuenta.",
                        type: 'error'
                    });
                }
            }
        }, error => {
            swal({
                title: 'Lo sentimos',
                text: "Ha ocurrido un error al momento de registro, por favor inténtelo nuevamente",
                type: 'error'
            });
        });
    }

    redirect() {
        /*window.location.href = "/#/login/" + this.bandera;*/
        this.router.navigate(['/login', this.bandera]);
    }
    verTerminosCondiciones() {
        this.modal.open();
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/register/register.component.ts